import Vue from 'vue'
import Router from 'vue-router'
import store from "/store/index";

import DengLu from '/page/dengLu'
import HouTai from '/router/houTai'
import NotFound from '/router/notFound'

Vue.use(Router)
const router = new Router({
  mode: "history",//此模式url不带‘#’号更美观
  routes: [
    {
      path: '/',
      component: DengLu
    },
    ...HouTai,
    // {
    //   path: '/ruKu',
    //   name: 'RuKu',
    //   meta: {
    //     breadcrumb: [
    //       {
    //         breadcrumbName: "操作入库"
    //       }
    //     ]
    //   },
    //   component: () => import('/page/ruKu/index.vue')
    // },
    // {
    //   path: '/saoMa',
    //   name: 'SaoMa',
    //   meta: {
    //     breadcrumb: [
    //       {
    //         breadcrumbName: "操作入库"
    //       }
    //     ]
    //   },
    //   component: () => import('/components/ruKu_saoMiao.vue')
    // },
    {
      path: '/chuKu',
      name: 'ChuKu',
      meta: {
        breadcrumb: [
          {
            breadcrumbName: "操作出库"
          }
        ]
      },
      component: () => import('/page/chuKu/index.vue')
    },
    {
      path: '/anZhuang',
      name: 'AnZhuang',
      meta: {
        breadcrumb: [
          {
            breadcrumbName: "操作安装"
          }
        ]
      },
      component: () => import('/page/anZhuang/index.vue')
    },
    {
      path: '/anZhuangOneForOne',
      name: 'AnZhuangOneForOne',
      meta: {
        breadcrumb: [
          {
            breadcrumbName: "操作安装"
          }
        ]
      },
      component: () => import('/page/anZhuang/index_one_for_one.vue')
    },
    {
      path: '/shouHou',
      name: 'ShouHou',
      meta: {
        breadcrumb: [
          {
            breadcrumbName: "售后登记"
          }
        ]
      },
      component: () => import('/page/shouHou/index.vue')
    },
    {
      path: '/kanBan',
      name: 'KanBan',
      meta: {
        breadcrumb: [
          {
            breadcrumbName: "看板查看"
          }
        ]
      },
      component: () => import('/page/kanBan/index.vue')
    },
    ...NotFound //Vue路由是从上到下执行的，所以404要放最后
  ]
})

function isLogin() {
  return store.getters.isLogin;
}

function isPermissioned(to) {
  let permission = store.getters.permissionInfo;
  let breadcrumb = to.meta.breadcrumb;
  let hasPermission = false;
  if (breadcrumb) {
    breadcrumb.forEach(item => {
      hasPermission = permission.indexOf(item.breadcrumbName) >= 0 ? true : hasPermission;
    });
  }
  return hasPermission;
}

router.beforeEach((to, from, next) => {
  let toPath = to.path;
  if (to.path !== from.path) {
    // NProgress.start();
  }

  let hasLoginURL = toPath.indexOf("/page/dengLu") >= 0;//是登录页
  let ifHome = toPath === "/";//是主页(无需登录)

  // 未登录的情况下，跳转到登录界面
  if (!isLogin() && !hasLoginURL && !ifHome) {
    next({
      path: '/'
    });
    // NProgress.done();
    return;
  }

  let hasSelfURL = toPath.indexOf("/houTai/miMa") >= 0;//是密码页
  //非权限页面，跳转到错误页
  if (!ifHome && !hasLoginURL && !hasSelfURL && !isPermissioned(to)) {
    next(...NotFound);
    return;
  }

  next();
});

router.afterEach(() => {
  // NProgress.done();
});

router.onError(error => {
  console.error("router error", error);
});


export default router;



// WEBPACK FOOTER //
// ./src/router/index.js